import { render, staticRenderFns } from "./StoriesArticleIllustratedMainImgSide.vue?vue&type=template&id=3e7f8eea&scoped=true&"
import script from "./StoriesArticleIllustratedMainImgSide.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMainImgSide.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMainImgSide.vue?vue&type=style&index=0&id=3e7f8eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7f8eea",
  null
  
)

export default component.exports